import { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Table,
  Menu,
  Dropdown,
  message,
  Input,
  Spin,
} from "antd";
import "./ColorsDefaultC.less";
import { colorsColumns, colorsHeader } from "./ColorsConfig";
import { SearchOutlined } from "@ant-design/icons";
import api from "../../utils/api";
import { MoreActionIcon } from "../../utils/icons";
import AddSingleColor from "../../components/pop-ups/default-modal/AddSingleColor";
import DefaultBulkEntry from "../../components/pop-ups/default-modal/MaterialDefaultBulkEntry";
import { CSVLink } from "react-csv";

type colorType = {
  _id: string;
  name: string;
  hexCode: string;
};

const ColorsDefaultC = () => {
  const [colors, setColors] = useState<colorType[]>([]);
  const [showSingleItemModal, setShowSingleItemModal] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [colorsSearched, setColorsSearched] = useState("");
  const [loading, setLoading] = useState<boolean>(true);
  const [buttonDisable, setButtonDisable] = useState(false);

  const [item, setItem] = useState<any>({});
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    api
      .get("material/colors")
      .then((resp: any) => {
        setLoading(false);
        setColors(resp);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const handleDelete = (id: string) => {
    api.delete(`material/color/${id}`).then(() => {
      setColors(colors.filter((item: any) => item._id !== id));
    });
  };

  const found = colors?.filter((item: any) => {
    if (!colorsSearched) {
      return true;
    }
    return item.name.toLowerCase().includes(colorsSearched.toLowerCase());
  });

  const sortedData = found.slice().sort((a: any, b: any) => {
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();
    return nameA.localeCompare(nameB);
  });

  const handleAdd = (values: any) => {
    if (edit) {
      api.put(`material/color/${item._id}`, values).then((resp: any) => {
        setColors(
          colors.map((data: any) =>
            data._id === item._id ? { ...values, _id: item._id } : data
          )
        );
      });
    } else {
      api.post("material/color/", values).then((resp: any) => {
        setColors([...colors, resp]);
      });
    }
    toggleSingleItemModal();
  };

  const handleAddCsv = (info: any) => {
    setButtonDisable(true);
    if (info.file.status === "done") {
      setButtonDisable(false);
      message.success("Successfully Uploaded");
      const resp = info.file.response.data;
      setColors(resp);
      toggleBulkModal();
    } else if (info.file.status === "error") {
      setButtonDisable(false);
      message.error("Uploading Failed!");
    }
  };

  const toggleBulkModal = () => {
    !showBulkModal ? setShowBulkModal(true) : setShowBulkModal(false);
  };

  const toggleSingleItemModal = () => {
    !showSingleItemModal
      ? setShowSingleItemModal(true)
      : setShowSingleItemModal(false);
  };

  const handleSingleItem = () => {
    setEdit(false);
    setItem({});
    toggleSingleItemModal();
  };

  const handleEdit = (data: any) => {
    setItem(data);
    setEdit(true);
    toggleSingleItemModal();
  };

  const tableColumns = [
    ...colorsColumns,
    {
      title: "Action",
      width: 100,
      render: (data: any) => {
        return (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="edit"
                  style={{ fontWeight: "bold" }}
                  onClick={() => handleEdit(data)}
                >
                  Edit
                </Menu.Item>
                <Menu.Item
                  key="delete"
                  style={{ fontWeight: "bold" }}
                  onClick={() => handleDelete(data._id)}
                >
                  Delete
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
          >
            <div style={{ cursor: "pointer" }}>
              <MoreActionIcon />
            </div>
          </Dropdown>
        );
      },
    },
  ];
  const handleBulkBtn = () => {
    !showBulkModal ? setShowBulkModal(true) : setShowBulkModal(false);
  };
  return (
    <div className="admin-ec-root">
      <DefaultBulkEntry
        buttonDisable={buttonDisable}
        showBulkModal={showBulkModal}
        toggleBulkModal={toggleBulkModal}
        url="material/upload/colors"
        handleAddCsv={handleAddCsv}
      />
      <AddSingleColor
        toggleSingleItemModal={toggleSingleItemModal}
        handleAdd={handleAdd}
        showSingleItemModal={showSingleItemModal}
        item={item}
        edit={edit}
      />
      <Row className="admin-ec-header" justify="space-between">
        <Col>
          <h1>Colors</h1>
        </Col>
        <Row gutter={12}>
          <Col>
            <Input
              className="search-manufacture-input"
              prefix={
                <SearchOutlined className="contractor-data-search-icon" />
              }
              placeholder="Search Colors"
              onChange={(e) => {
                setColorsSearched(e.target.value);
              }}
            />
          </Col>
          <div className="contractor-data-vertical-line " />
          <Col>
            <Button
              className="admin-ec-add-single-btn"
              onClick={handleSingleItem}
            >
              Add Single item
            </Button>
          </Col>
          <Col>
            <Button
              className="admin-ec-add-btn"
              type="primary"
              onClick={handleBulkBtn}
            >
              Bulk Entry
            </Button>
          </Col>
        </Row>
      </Row>
      {loading ? (
        <Row style={{ padding: "80px 0px" }} justify="center">
          <Spin size="large" />
        </Row>
      ) : (
        <>
          <hr style={{ border: "1px solid #E8E8E8", marginBottom: 30 }} />
          <Button
            className="default-bulk-btn"
            style={{ margin: "0px 20px 10px" }}
            type="primary"
          >
            <CSVLink
              data={colors}
              filename={"colors"}
              headers={colorsHeader}
              enclosingCharacter={""}
            >
              Download CSV
            </CSVLink>
          </Button>
          {colors.length > 0 && (
            <Table
              scroll={{ x: "900px" }}
              rowKey="_id"
              columns={tableColumns}
              dataSource={sortedData}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ColorsDefaultC;
